import { Form, Formik } from "formik";
import React, { useState, useEffect, useCallback } from "react";
import { InputGroup, Form as ReactForm, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { loginAction } from "../../containers/login/actions";
import { regex } from "../../utils/regex";
import CustomButton from "../Buttons/CustomButton";

const validationSchema = Yup.object({
  email: Yup.string()
    .required("email can not be empty")
    .email("email must be a valid email address")
    .matches(regex.email, "email must be a valid email address"),
  password: Yup.string().required("password can not be empty").min(8),
});

function Login() {
  const [state, setState] = useState({
    show_pass: false,
  });
  const [showLoader, setShowLoader] = useState(false);
  const stopLoader = () => setShowLoader(false);
  const params = new URLSearchParams(document.location.search.substring(1));
  const redirectUrl = params.get("redirect_url");
  const intendedUrl = useSelector((reduxState) => reduxState.insurancereducer.intendedUrl);
  const [initialState, setInitialState] = useState({
    email: "",
    password: "",
    remember_me: false,
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const handleSubmit = (values, actions) => {
    setShowLoader(true);
    const data = {
      email: values.email,
      password: values.password,
      remember_me: values.remember_me,
    };
    if (redirectUrl) {
      data.redirect_url = encodeURIComponent(redirectUrl) || "";
    }
    dispatch(loginAction(data, stopLoader, actions, history, intendedUrl));
  };

  const handleRememberMe = useCallback((setValue, field, value) => {
    if (!value) localStorage.setItem("remember_me", true);
    else localStorage.removeItem("remember_me");
    setValue(field, !value);
  }, []);

  useEffect(() => {
    if (localStorage.getItem("remember_me")) {
      setInitialState((prev) => ({ ...prev, remember_me: true }));
    }
  }, []);
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <Formik initialValues={initialState} onSubmit={handleSubmit} validationSchema={validationSchema} enableReinitialize>
      {({ values, handleChange, handleBlur, setFieldValue, touched, errors }) => {
        return (
          <Form className="loginForm">
            <h6 className="mb-3">Login</h6>
            <div>
              <InputGroup>
                <input
                  size="lg"
                  id="email"
                  name="email"
                  // component={TextInput}
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="E-mail*"
                  className="form-control"
                />
                <InputGroup.Text>
                  <i className="fa-regular fa-envelope fa-fw" aria-hidden="true" />
                </InputGroup.Text>
              </InputGroup>
              {touched.email && errors.email && <div className="text-danger pl-2">{errors.email}</div>}
            </div>

            <InputGroup className="mt-4">
              <input
                size="lg"
                id="password"
                name="password"
                // component={TextInput}
                value={values.password}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Password*"
                type={state.show_pass ? "text" : "password"}
                className="form-control"
              />
              <InputGroup.Text
                className="cursor-pointer"
                onClick={() =>
                  setState({
                    ...state,
                    show_pass: !state.show_pass,
                  })
                }
              >
                {!state.show_pass ? <i className="fa-regular fa-fw fa-eye" /> : <i className="fa-regular fa-fw fa-eye-slash" />}
              </InputGroup.Text>
            </InputGroup>
            {touched.password && errors.password && <div className="text-danger pl-2">{errors.password}</div>}
            <div className="mt-4">
              <ReactForm.Check
                id="remember"
                onChange={() => handleRememberMe(setFieldValue, "remember_me", values.remember_me)}
                value={values.remember_me}
                label="Remember me"
                type="checkbox"
                name="remember_me"
                checked={values.remember_me}
              />
            </div>

            <div className="mt-3 text-center">
              {showLoader ? (
                <div className="d-inline-flex p-0 text-black align-items-center mt-2">
                  <p className="mb-0 text-black fw-bolder me-2">Loading...</p>
                  <Spinner animation="border" size="sm" />
                </div>
              ) : (
                <CustomButton variant="primary" className="w-100" type="submit" aria-label="Member Login">
                  Member Login
                </CustomButton>
              )}
              <a className="w-100 mt-4 d-block text-lg" href="/forget-password">
                Forgot your password?
              </a>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}
export default Login;
